import React from 'react';
import TopBar from './TopBar/TopBar';
import { Button, NavbarToggler } from 'reactstrap';

import './Nav.css';

const Nav = ({ }) => {
    return (
        <div className="Nav">
            <TopBar />
        </div>
    );
}

export default Nav;
